import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  box-shadow: 0 0 20px 0 rgb(0 0 0 / 8%);
    background-color: #ffffff;
    padding: 34px 22px 10px;
    margin-bottom: 20px;
`;
export const Detail = styled.div`
  display: flex;
  flex: 1;
`;
export const TrackBox = styled.div`
    .rescheduleMsg{
      text-align: left;
    }
  > p {
    display: flex;
    justify-content: space-between;
    color: #00b3ff;
    font-size: 14px;
        font-family: "latobold";

    > span {
      cursor: pointer;
      display: flex;
    }
    .timerSpan {
      width: 100%;
      > div {
        flex: 1;
        justify-content: space-evenly;
      }
    }
  }
  >div{
    cursor: pointer;
  }
`

export const Address = styled.div`
  h2 {
    font-size: 22px;
    margin: 0;
    color: #000000;
    padding: 2px 0;
  }
 
`;

export const Images = styled.div`
  max-width: 200px;
  margin-right: 25px;
`
export const Slide = styled.div`
    border: 1px solid #e8e8e8;
    border-radius: 8px;
`
export const Pallets = styled.div`
    text-align: center;
    background: #fff;
    margin: 0 12px;
    > div {
        height: 184px;
        justify-content: center;
        display: flex;
        align-items: center;
        padding: 15px;
        img {
        width: 100%;
    }
    }

`
export const Info = styled.div`
  display: grid;
  >em{
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-family: "latobold";
    >p{
      color: grey;
      cursor: pointer;
      display: flex;
      text-decoration: underline;
    }
    > span {
      cursor: pointer;
      color: #00b3ff;
      display: flex;
      text-decoration: underline;
    }
  }
  > p {
    display: flex;
    justify-content: space-between;
    margin: 3px 0;
    font-size: 14px;
    align-items: center;
    > span {
      font-family: "latobold";
      width: 140px;
      display: flex;
      align-items: center;
    }
  }
`

export const Description = styled.div`
  flex: 1;
  > h2 {
    color: #930000;
    font-size: 18px;
    font-family: "latobold";
  }
  > h3 {
     color: #000000;
    font-size: 14px;
    font-family: "latobold";
    margin-top: 4px;
  }
  > p {
        font-size: 14px;
         color: #000000;
         font-family: "latomedium";
         margin-bottom: 10px;
         margin-top: 2px;

         cursor: pointer;
         color: #2525ed;
         margin: 0;
         height: fit-content;
  }
`
export const PurchaseOrder = styled.div`
  display : flex;
  align-items: center;
  gap: 15px;
    white-space: nowrap;
        margin: 10px 0;
  > h3 {
    font-size: 14px;
    font-family: "latobold";
  }
  .poNumberWidth{
    max-width: 200px;
    overflow: hidden;
  }
  .app-input-text {
    margin: 0;
    display: flex;
    gap: 10px;
    > p {
      color: #00b3ff;
      font-size: 14px;
      cursor:pointer;
    }
  }
`

export const AccordionSummaryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(191px, 1fr));

  width: 100%;
  > div {
    padding: 0 5px;
  }
  h2 {
    font-size: 16px;
    color: #000000;
  }
  p {
    color: #5c666b;
  }
  h3 {
    color: #000000;
    font-size: 17px;
    font-family: "latobold";
  }
  @media (max-width: 650px) {
    grid-template-columns: 1fr 1fr;
  }
`;
export const AccordionDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(191px, 1fr));
  padding-right: 32px;
  width: 100%;
  > div {
    padding: 0 5px;
  }
  h2 {
    font-size: 16px;
    color: #000000;
  }
  p {
    color: #5c666b;
  }
  @media (max-width: 650px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const PrintContainer = styled.div`
  margin-left: 50px;
  margin-right: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #0a5587;

  p,a {
    background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
    padding: 4px 10px;
    color: #fff !important;
    border-radius: 5px;
    cursor: pointer;
  }
  span{
    background: grey;
    padding: 4px 10px;
    color: #fff !important;
    border-radius: 5px;
  }
  @media (max-width:767px) {
    flex-direction: column;
    p,a {
      width: 100%;
    display: inline-flex;
    justify-content: center;
    }
  }
`;
export const DownloadBOL = styled.div`
cursor:pointer;
`
export const PayWith = styled.div`
  
`;
export const Heading = styled.div`
  font-size: 20px;
  color: #000000;
  line-height: 25px;
  font-family: 'latobold';
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  Button {
    color: #00b3ff;
    background: #ffffff;
    font-size: 20px;
  }
`;
export const AccountSection = styled.div`
  display: flex;
  border: 1px solid #e0e0e0;
  padding: 10px 15px;
`;
export const AccountType = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  > div {
    > div {
      display: flex;
      > div {
        flex: 1;
        &:first-child {

          > div > div > div > div {
            display: flex;
            flex-direction: column;
            margin: 0 !important;
            > div {
              min-height: 40px;
              display: flex;
              align-items: center;
              .radio-label {
                color: black !important;
                margin: 0;
              }
            }
          }
        }
        &:nth-child(2) {
          max-width: 400px;
          padding-left: 38px;
          > div > div {
            .radio-label {
            }           
          }
          .payment {
            label {
              font-size: 16px;
              color: #212529;
              letter-spacing: normal;
              .StripeElement,
              input {
                border: solid 1px #dddddd;
              }
            }
            Button {
              height: 36px;
            }
          }
        }
      }
      @media only screen and (max-width: 725px) {
        flex-direction: column;
        > div {
          flex: 1;
          &:first-child {
            max-width: 100%;
            border: none;
            > div > div > div > div {
              flex-direction: row;
            }
          }
          &:nth-child(2) {
            max-width: 100%;
            padding-left: 0;
          }
        }
      }
    }
  }
 
`;

export const ChatBlockStyle = styled.div`
  position: relative;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 15px 2px 15px;
    border-bottom: 2px solid #dedede;
    background-color: #005586;
    p{
      color: #fff;
      font-size: 20px;
    }
  }

  .footer {
    position: relative;
    background: #f1f1f1;
    height: 70px;
    .enter-btn {
      padding: 0;
      position: absolute;
      right: 16px;
      bottom: 0;
      outline: none;
      img {
        max-width: 40px;
        margin: -10px;
        padding: 9px;   
        position: relative;
        top: 18px;
      }
    }
    .enter-btn:focus {
      outline: none;
    }
    textarea {
      ::placeholder {
        font-size: 16px;
        margin-top: 8px;
     }
    }
  }

  /* Button used to open the chat form - fixed at the bottom of the page */
  .open-button {
      border: none;
      cursor: pointer;
      position: fixed;
      bottom: 23px;
      right: 28px;
      background: transparent;
      z-index: 1;
  }

  .unread-icon{
    background: #e31616db;
    color: #fff;
    width: 21px;
    height: 21px;
    border-radius: 50%;
    font-size: 14px;
    text-align: center;
    position: fixed;
    bottom: 63px;
    right: 39px;
    z-index: 1;
  }

  /* The popup chat - hidden by default */
  .chat-popup {
    display: block;
    position: absolute;
    top: 40px;
    right: 0px;
    border: 2px solid #f1f1f1;
    z-index: 9;
    border-radius: 10px;
    overflow: hidden;
    min-width: 350px;
    @media (max-width:490px) {
      right: -115px;
    }
    @media (max-width:391px) {
      right: -89px;
    }
  }
  .chat-popup-short-view{
    display: block;
    position: fixed;
    bottom: 0;
    border: 2px solid #f1f1f1;
    z-index: 9;
    border-radius: 10px;
    overflow: hidden;
    min-width: 350px;
  }
  .chat-window {
    height: 400px;
    overflow: auto;
    padding: 10px 3px;
    @media (max-width:1250px) {
      height: 350px;
    }
  }  
  .chat-window-short-view{
    height: 300px !important;
  }

  .sender-initial{
    width: 25px;
    height: 23px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 13px;
    margin: 0 4px;
  }

  .sender-initial-buyer{
    background-color: #0a5587;
    color: #fff;

  }

  .sender-initial-seller{
    background-color: #69BBE0;
    color:#000;
  }

  .chat-listing-user{
    display:flex;
    flex-direction: row-reverse;
    svg {
      margin: 10px;
    }
  }

  .chat-listing-admin{
    display:flex;
    svg {
      margin: 10px;
    }
  }

  .chat-container {
    border: 1px solid #dedede;
    background-color: #69BBE0;
    color:#000;
    border-radius: 0px 10px 10px 10px;  
    padding: 0 10px;
    max-width: 220px;
    border: 1px solid #69BBE0;
    font-size: 14px;
    user-select: text;
    cursor: text;
  }

  .darker {
    border-color: #ccc;
    border-radius: 10px 0px 10px 10px;
    background-color: #0a5587;
    color: #fff;
  }

  .chat-container::after {
    content: "";
    clear: both;
    display: table;
  }

  .chat-container img {
    float: left;
    max-width: 45px;
    width: 100%;
    margin-right: 20px;
    border-radius: 50%;
  }

  .chat-container img.right {
    float: right;
    margin-left: 20px;
    margin-right:0;
  }

  .time-right {
    float: right;
    color: #aaa;
    font-size: 12px;
  }

  .time-left {
    float: left;
    color: #999;
    font-size: 12px;
  }

  /* Add styles to the form container */
  .form-container {
    min-width: 350px;
    background-color: white;
    @media (max-width:600px) {
      /* height: 100%; */
      display: grid;
      grid-template-rows: auto 1fr auto;
      /* min-width: 100%; */
    }
  }

  /* Full-width textarea */
  .form-container textarea {
    width: 100%;
    padding: 10px 57px 0px 15px;
    border: none;
    background: #f1f1f1;
    resize: none;
    height: 100%;
  }

  /* When the textarea gets focus, do something */
  .form-container textarea:focus {
    background-color: #ddd;
    outline: none;
  }

  /* Set a style for the submit/send button */
  .form-container .btn {
    border: none;
      cursor: pointer;
      opacity: 0.8;
      top: 0;
  }

  /* Add a red background color to the cancel button */
  .form-container .cancel {
    background-color: transparent;
      width: auto;
      padding: 0;
      margin: 0;
      img {
        width: 16px;
      }
  }

  /* Add some hover effects to buttons */
  .form-container .btn:hover, .open-button:hover {
    opacity: 1;
  }

  .overlay-style{
    pointer-events: none;
    opacity: 0.8;
  }

  .chat-initiate-style{
    font-size: 12px;
    text-align: center;
    margin-top: 44%;
    position: absolute;
    padding: 0 36px;
  }
  .chat-initiate-style-short-view{
    margin-top: 125px;
  }

  /* loader css */
  .loader-overlay {
    width: 100%;
    height: 0px;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .loader-text {
    margin-top: 90px;
    font-size: 16px;
    font-family: 'latobold';
  }

  @keyframes connectingAnimation {
      0%, 100% {
          content: "Connecting.";
      }
      33% {
          content: "Connecting..";
      }
      66% {
          content: "Connecting....";
      }
  }

  .loader-text::after {
      content: "Connecting";
      animation: connectingAnimation 1.5s infinite;
  }

`;

export const AccountDetail = styled.div``;
